import { render } from "./DealersearchHeading.vue?vue&type=template&id=38ea1330"
import script from "./DealersearchHeading.vue?vue&type=script&lang=js"
export * from "./DealersearchHeading.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominikheun/Coding/beulco-website-typo3/extensions/user_dealersearch/Resources/Private/Vue/dealersearch-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__